import { render, staticRenderFns } from "./m-shop-list.vue?vue&type=template&id=56578359&scoped=true"
import script from "./m-shop-list.vue?vue&type=script&lang=js"
export * from "./m-shop-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56578359",
  null
  
)

export default component.exports